<template>
  <div v-if="isShow" class="video">
    <swiper :options="swiperOption" v-if="story.videoBanners.length">
      <swiper-slide class="slide-1" v-for="(item,index) in story.videoBanners" :key="index">
        <div class="cardBg" @click="playVideo(item.videoGroup,index,story.videoBanners)">
          <img :src="item.imageUrl" alt />
          <div
            class="banner-title"
            style="position: absolute;bottom:10px;color:#ffffff;font-size:19px;"
          >
            <p style="float:left; margin-top:5px;">
              <b>＜</b>
              {{ item.videoGroup}}
              <b>＞</b>
            </p>
            <p style="float:left; left:100px;margin-top:5px;">{{item.title}}</p>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="video-part" v-for="(item,index) in story.videoBlocks" :key="index">
      <div style="overflow:hidden">
        <div class="blue"></div>
        <p class="title">{{item.videoGroup}}</p>
        <!-- <p v-show="item.count>3" class="change" @click="newContent(item,index)">换一批
          <img
          class="turn"
          v-show="item.count>3"
          src="../../assets/images/turn.png"
          alt
        />
        </p> -->
      </div>
      <div
        class="video-img"
        v-for="(v,i) in item.videos"
        :key="i"
        @click="playVideo(item.videoGroup,i,item.videos)"
      >
        <img :src="v.imageUrl" alt />
        <p class="img-title">{{v.title}}</p>
        <!-- <p class="img-sum">{{v.summary}}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  props: ["navID"],
  metaInfo: {
  meta: [{
      name: 'keywords',
      content: '51Testing,软件测试,软件测试培训,视频广场',
    },{
      name: 'description',
      content: '汇聚公司新闻,合作动态,班级活动,学员心得,视频广场等51Testing软件测试培训网的最新资讯.',
    }]
  },
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      isShow: Boolean,
      swiperOption: {
        // sliderPreView:1,
        autoplay: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          type: "custom",
          renderCustom: function(swiper, current, total) {
            const activeColor = "#ffffff";
            const normalColor = "#c9caca";
            let color = "";
            let paginationStyle = "";
            let html = "";
            for (let i = 1; i <= total; i++) {
              if (i === current) {
                color = activeColor;
              } else {
                color = normalColor;
              }
              paginationStyle = `margin-bottom:5px;background:${color};opacity:1;margin-right:10px;width:7px;height:7px`;
              html += `<span class="swiper-pagination-bullet" style=${paginationStyle}></span>`;
            }
            return html;
          }
        }
      },
      story: {
        videoBanners: [],
        videoBlocks: [{ videoGroup: "", videos: [] }]
      },
      number: 1,
      index: 0,
      videoGroup: "",
      stop: false,
      maxPage: 1,
    };
  },
  watch: {
    navID: {
      handler: function() {
        if (this.navID === 5) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      },
      immediate: true
    },
    number: {
      handler() {
        this.getVideo();
      }
    },
    num: {
      handler() {
        this.getVideoScience(); //科普时间
      }
    }
  },
  mounted() {
    this.getPageInfo();
  },

  methods: {
    //点击事件
    newContent(val,index) {
      if(val.count<=4)return
      this.index = index
      this.maxPage = val.count
        if (this.number*4 >= this.maxPage) {
          val.index = 1;
        } else {
          val.index ++ ;
          this.videoGroup = val.videoGroup;
        }
        this.number = val.index
    },
    getPageInfo() {
      this.axios
        .get("/api/consume/Information/VideoIndex", {
          params: {
            num: 4
          }
        })
        .then(res => {         
          this.story = res.data;
          // console.log(this.story)
          this.story.videoBlocks.forEach(item=>{
            item.index=1
          })
        });
    },
    getVideo() {
      this.axios
        .get("/api/consume/Information/PageList", {
          params: {
            page: this.number,
            rows: 4,
            Type: 5,
            videoGroup: this.videoGroup
          }
        })
        .then(res => {
          // console.log(res.data.results)
          this.story.videoBlocks[this.index].videos = res.data.results;
        });
    },
    playVideo(val, index,list) {
      if (!this.number) {
        this.number = 1;
      }
      var arr = []
      arr[0]=list[index]
      list.forEach(item=>{
        if(item.id !== list[index].id){
          arr.push(item)
          localStorage.setItem("videoList", JSON.stringify(arr[0]))
        }
      })
      this.$router.push({
        path: `/video.html`,
        query: {
          id: val,
          PageIndex: this.number,
          // videoList: JSON.stringify(arr[0]),
          index: index
        }
      });
    },
    //  beforeRouteLeave(to, from, next) {
    //      // 设置下一个路由的 meta
    //     to.meta.keepAlive = true;  // B 跳转到 A 时，让 A 缓存，即不刷新
    //     next();
    // },
  }
};
</script>

<style>
.video {
  background: #ffffff;
  /* margin-bottom: 120px; */
}
.video .swiper-container {
  margin: 0 auto;
  overflow: hidden;
  width: 90%;
}

.video .swiper-slide img {
  width: 675px;
  height: 356px;
  z-index: 1;
}
.video .banner-title {
  overflow: hidden;
  /* background-image: url("/assets/images/top_vedio_title_bg.png"); */
  background: url("static/top_vedio_title_bg.png") no-repeat center;
  width: 100%;
  height: 62px;
  margin-top: -10px;
}
.video .banner-title p:nth-child(2) {
  width: 400px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

}
.video .video-part {
  background: #ffffff !important;
  overflow: hidden;
  margin-top: 56px;
  padding: 0 13.5px;
  /* height:600px; */
}
.video .video-part .change {
  /* width: 400px; */
  float: right;
  color: #747474;
  font-size: 24px;
  margin-right: 20px;
  line-height: 43px;
}
.video .video-part .turn {
  float: right;
  margin-top: 7px;
  margin-left: 22px;
}
.video .blue {
  width: 6px;
  height: 30px;
  background: #64b3f1;
  float: left;
  margin-top: 5px;
  margin-left: 22px;
}
.video .title {
  font-size: 32px;
  color: #282828;
  font-weight: bold;
  float: left;
  margin-left: 22px;
}
.video .video-img {
  float: left;
}
.video .video-img img {
  width: 334px;
  height: 198px;
  margin-left: 21px;
  margin-top: 35px;
}
.video .img-title {
  margin-left: 22px;
  font-size: 26px;
  color: #444;
  width: 334px;
  height: 76px;
  /* height: 120px; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.video .img-sum {
  margin-left: 22px;
  font-size: 22px;
  color: #8b8b8b;
  margin-top: 19px;
}
.video .swiper-pagination-fraction,
.video .swiper-pagination-custom,
.video .swiper-container-horizontal > .swiper-pagination-bullets {
  left: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/information/VideoList.vue